import { useRef } from 'react';
import { FaEllipsisH } from 'react-icons/fa';

interface ContextMenuProps {
  entryRefId: string;
  onContextMenuOpen: (entryRefId: string, position: {x: number, y: number}|null) => void;
  isVisible: boolean;
}

const ContextMenu = ({
  entryRefId,
  onContextMenuOpen,
  isVisible,
}: ContextMenuProps) => {
  const menuButtonRef = useRef<HTMLButtonElement>(null);

  const openContextMenu = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (!menuButtonRef.current) return;

    const buttonRect = menuButtonRef.current.getBoundingClientRect();
    const menuX = buttonRect.left;
    const menuY = buttonRect.bottom + 5;

    onContextMenuOpen(entryRefId, {x: menuX, y: menuY});
  };

  if (!isVisible) {
    return null;
  }

  return (
    <button
      ref={menuButtonRef}
      className="absolute top-1 right-1 p-1 rounded-full bg-gray-100 hover:bg-gray-200 text-gray-600"
      onClick={openContextMenu}
      style={{
        zIndex: 10,
        position: 'absolute',
        top: '4px',
        right: '4px'
      }}
    >
      <FaEllipsisH size={12} />
    </button>
  );
};

export default ContextMenu;
